import { gql } from 'apollo-boost';

export default gql`
  mutation updateGroceryOrderStatus($input: UpdateGroceryOrderStatusInput!) {
    updateGroceryOrderStatus(input: $input)
  }
`;
